export class DocumentType {

	public FichaCadastral = 1;
	public Documentos = 2;
	public ImpostodeRenda = 3; 
	public CertidoeseMatriculas = 4; 
	public DocumentosdeGarantidores = 5; 
	public Garantias = 6;
	public Contratos = 7;
	public DemonstracoesFinanceiras = 8; 
	public EstatutoContratoSocial = 9; 
	public DocumentosdosSociosAcionistas = 10; 
	public ConsultasSERASA = 11; 
	public ConsultasTJ = 12; 
	public Outros = 13;
	public DocumentacaoHistorica = 14;

	getArray() {
		return [	
			this.FichaCadastral,
			this.Documentos,
			this.ImpostodeRenda,
			this.CertidoeseMatriculas,
			this.DocumentosdeGarantidores,
			this.Garantias,
			this.Contratos,
			this.DemonstracoesFinanceiras,
			this.EstatutoContratoSocial,
			this.DocumentosdosSociosAcionistas,
			this.ConsultasSERASA,
			this.ConsultasTJ,
			this.Outros,
			this.DocumentacaoHistorica
		]
	}

	getDescricao(documentType: number) {
		switch (documentType) {
			case 1: return "Ficha Cadastral";
			case 2: return "Documentos";
			case 3: return "Imposto de Renda";
			case 4: return "Certidões e Matrículas";
			case 5: return "Documentos de Garantidores";
			case 6: return "Garantias";
			case 7: return "Contratos";
			case 8: return "Demonstrações Financeiras";
			case 9: return "Estatuto/Contrato Social";
			case 10: return "Documentos dos Sócios/Acionistas";
			case 11: return "Consultas SERASA";
			case 12: return "Consultas TJ";
			case 13: return "Outros";
			case 14: return "Documentação Histórica"
			default: return "N/D";
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/models/document-type.ts